import isObject from 'lodash.isobject';
import {SingleTenantProps} from '../constants/types';

export const sanitize = (object: any) => {
  if (!isObject(object)) return object;

  const copy = {...object};
  const keys = Object.keys(copy);

  keys.forEach((key) => {
    if (typeof copy[key] === 'string') {
      copy[key] = copy[key].trim();
      if (copy[key] === '') {
        copy[key] = null;
      }
    }
  });

  return copy;
};

export const camelToUpperSnakeCase = (string: string) => {
  return string.replace(/[A-Z]/g, (letter) => `_${letter}`).toUpperCase();
};

export const getSortedParams = (params = {}) => {
  const keys = Object.keys(params);
  const sorted = keys.sort();

  return sorted.reduce((acc, key) => {
    return ({
      ...acc,
      [key]: params[key]
    });
  }, {});
};

export const getTenantFromRoute = (pathname: string) => {
  const loginPathChunks = pathname.split('/').filter((item) => item);

  if (loginPathChunks.length < 2) {
    return null;
  }

  const loginTenant = loginPathChunks[0];
  return loginTenant;
};

export const isTenantValid = (
    tenants: SingleTenantProps[], tenantSlug: string | null
) => {
  if (!tenantSlug || !tenants?.length) return false;

  const currentTenant = tenants.find(({slug}) => slug === tenantSlug);

  return !!currentTenant;
};

export const parseJSON = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};
